import {
  all,
  call,
  fork,
  put,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";
import { API_GET, API_POST, API_PUT } from "../../helpers/api";
import * as actions from "../actions/organizations";
import {
  ORGANIZATION_SEARCH_REQUESTED,
  GET_ORGANIZATION_REQUESTED,
  ORGANIZATION_FIND_BY_TERM_SEARCH_REQUESTED,
  GET_USER_LIMITS_REQUEST,
  GET_USERS_LIMITS_REQUEST,
  UPDATE_USER_LIMITS_REQUEST,
  UPDATE_ORGANIZATION_LIMITS_REQUEST,
  GET_REGISTRATION_GENERAL_STATUS_REQUESTED,
  GET_REGISTRATION_PARTICIPANT_STATUS_REQUESTED,
  GET_REGISTRATION_GENERAL_COMMITMENT_STATUS_REQUESTED,
  GET_REGISTRATION_COMMITMENT_STATUS_REQUESTED,
} from "../types";

function* watchGetOrganizations() {
  yield takeLatest(ORGANIZATION_SEARCH_REQUESTED, getOrganizations);
}

function* getOrganizations(action) {
  try {
    const res = yield call(apiGetOrganizations, action.payload);
    yield put(actions.organizationSearchSucceeded(res.data.items));
  } catch (err) {
    yield put(actions.organizationSearchFailed());
  }
}
function* watchGetFindByTermOrganizations() {
  yield takeLatest(
    ORGANIZATION_FIND_BY_TERM_SEARCH_REQUESTED,
    getFindByTermOrganizations
  );
}

function* getFindByTermOrganizations(action) {
  try {
    const res = yield call(apiGetFindByTermOrganizations, action.payload);

    yield put(actions.organizationFindByTermSearchSucceeded(res.data));
  } catch (err) {
    yield put(actions.organizationFindByTermSearchFailed());
  }
}

function* watchGetOrganization() {
  yield takeEvery(GET_ORGANIZATION_REQUESTED, getOrganization);
}

function* watchGetUserLimits() {
  yield takeEvery(GET_USER_LIMITS_REQUEST, getUserLimits);
}
function* watchGetUsersLimits() {
  yield takeEvery(GET_USERS_LIMITS_REQUEST, getUsersLimits);
}

function* watchUpdateUserLimits() {
  yield takeEvery(UPDATE_USER_LIMITS_REQUEST, updateUserLimits);
}
function* watchUpdateOrganizationLimits() {
  yield takeEvery(UPDATE_ORGANIZATION_LIMITS_REQUEST, updateOrganizationLimits);
}

function* watchGetRegistrationGeneralStatus() {
  yield takeEvery(
    GET_REGISTRATION_GENERAL_STATUS_REQUESTED,
    getRegistrationGeneralStatus
  );
}

function* watchGetRegistrationParticipantStatus() {
  yield takeEvery(
    GET_REGISTRATION_PARTICIPANT_STATUS_REQUESTED,
    getRegistrationParticipantStatus
  );
}

function* watchGetRegistrationCommitmentStatus() {
  yield takeEvery(
    GET_REGISTRATION_COMMITMENT_STATUS_REQUESTED,
    getRegistrationCommitmentStatus
  );
}

function* watchGetRegistrationGeneralCommitmentStatus() {
  yield takeEvery(
    GET_REGISTRATION_GENERAL_COMMITMENT_STATUS_REQUESTED,
    getRegistrationGeneralCommitmentStatus
  );
}
function* getOrganization(action) {
  try {
    const res = yield call(apiGetOrganization, action?.payload);
    yield put(actions.getOrganizationSucceeded(res.data));
  } catch (err) {
    yield put(actions.getOrganizationFailed());
  }
}

function* getUserLimits(action) {
  try {
    const res = yield call(apiGetUserLimits, action.payload);
    yield put(actions.getUserLimitsSucceeded(res.data));
  } catch (err) {
    yield put(actions.getUserLimitsFailed());
  }
}

function* getUsersLimits(action) {
  try {
    if (action?.payload?.organizationId !== null) {
      const res = yield call(apiGetUsersLimits, action.payload);
      yield put(actions.getUsersLimitsSucceeded(res.data));
    } else {
      yield put(actions.getUsersLimitsSucceeded([]));
    }
  } catch (err) {
    yield put(actions.getUsersLimitsFailed());
  }
}

function* getRegistrationGeneralStatus(action) {
  try {
    const res = yield call(apiGetOrganizationRegistrationGeneralStatus);

    yield put(actions.getRegistrationGeneralStatusSucceeded([res?.data]));
  } catch (error) {
    yield put(actions.getRegistrationGeneralStatusFailed());
  }
}

function* getRegistrationParticipantStatus(action) {
  try {
    const res = yield call(
      apiGetOrganizationRegistrationParticipantStatus,
      action.payload
    );

    yield put(actions.getRegistrationParticipantStatusSucceeded(res.data));
  } catch (error) {
    yield put(actions.getRegistrationParticipantStatusFailed());
  }
}

function* getRegistrationCommitmentStatus(action) {
  try {
    const res = yield call(
      apiGetOrganizationRegistrationCommitmentStatus,
      action.payload
    );
    yield put(actions.getRegistrationCommitmentStatusSucceeded(res.data));
  } catch (err) {
    yield put(
      actions.getRegistrationCommitmentStatusFailed(
        err?.response?.data?.message
      )
    );
  }
}

function* getRegistrationGeneralCommitmentStatus(action) {
  try {
    const res = yield call(
      apiGetOrganizationRegistrationGeneralCommitmentStatus
    );
    yield put(
      actions.getRegistrationGeneralCommitmentStatusSucceeded(res.data)
    );
  } catch (error) {
    yield put(actions.getRegistrationGeneralCommitmentStatusFailed());
  }
}

function* updateUserLimits(action) {
  try {
    const res = yield call(apiUpdateUserLimits, action.payload);
    yield put(actions.updateUserLimitsSucceeded(res.data));
  } catch (err) {
    yield put(actions.updateUserLimitsFailed(err?.response?.data?.message));
  }
}
function* updateOrganizationLimits(action) {
  try {
    const res = yield call(apiUpdateOrganizationLimits, action.payload);
    yield put(actions.updateUserLimitsSucceeded(res.data));
    yield put(actions.getUsersLimitsSucceeded(res.data));
  } catch (err) {
    yield put(actions.updateUserLimitsFailed(err?.response?.data?.message));
  }
}

export default function* organizationSaga() {
  yield all([
    fork(watchGetOrganizations),
    fork(watchGetFindByTermOrganizations),
    fork(watchGetOrganization),
    fork(watchUpdateUserLimits),
    fork(watchUpdateOrganizationLimits),
    fork(watchGetUserLimits),
    fork(watchGetUsersLimits),
    fork(watchGetRegistrationGeneralStatus),
    fork(watchGetRegistrationParticipantStatus),
    fork(watchGetRegistrationCommitmentStatus),
    fork(watchGetRegistrationGeneralCommitmentStatus),
  ]);
}

function apiGetOrganizations(v) {
  return API_GET("organization", {
    organizationSearchParam: v ?? null,
    page: 0,
    size: 1000,
  });
}
function apiGetFindByTermOrganizations(value) {
  return API_GET(
    `organization/findByTerm?term=${value?.date}${
      value?.value ? `&organizationSearchParam=${value?.value} ` : ""
    }`
  );
}

function apiGetOrganization(organizationId) {
  return API_GET(`organization/${organizationId}`);
}

function apiGetUserLimits() {
  return API_GET("limit-user/current");
}

function apiGetUsersLimits(params) {
  return API_GET("limit-user/list", {
    ...params,
    page: params?.page || 0,
    size: 10,
  });
}

function apiUpdateUserLimits(payload) {
  return API_PUT("limit-user/update", {
    ...payload,
  });
}
function apiUpdateOrganizationLimits(payload) {
  return API_PUT("limit-organization/update", {
    ...payload,
  });
}

function apiGetOrganizationRegistrationGeneralStatus() {
  return API_GET("organization/registration/general-participant-status");
}

function apiGetOrganizationRegistrationParticipantStatus(reqParams) {
  let date = reqParams.date === "" ? null : reqParams.date;
  let organizationId =
    reqParams.organizationId === "" ? null : reqParams.organizationId;
  return API_GET("organization/registration/participant-status", {
    date,
    organizationId,
    page: reqParams?.page || 0,
    size: 10,
    participantStatus: reqParams?.participantStatus,
  });
}

function apiGetOrganizationRegistrationGeneralCommitmentStatus() {
  return API_GET("organization/registration/general-commitment-status");
}

function apiGetOrganizationRegistrationCommitmentStatus(reqParams) {
  let date = reqParams.date === "" ? null : reqParams.date;
  let organizationId =
    reqParams.organizationId === "" ? null : reqParams.organizationId;
  return API_GET("organization/registration/commitment-status", {
    date,
    organizationId,
    plantId: reqParams?.plantId ?? null,
    yekgCommitmentStatus: reqParams?.yekgCommitmentStatus ?? null,
    page: reqParams?.page || 0,
    size: 10,
  });
}
